import {
  Input, SimpleChanges, OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {CategoryService} from "../../services/category/category.service";

import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {ImageVM} from "../../models/ImageVM.model";
import {SharingService} from "../../services/sharing/sharing.service";
import {CompanyService, currentCompany} from "../../services/company-service/company-service";
import {AlertService} from "../../services/alert/alert.service";


@Component({

  selector: 'rw-service-profile',  // <home></home>

  styles: [require('./service-profile.component.css')],

  template: require('./service-profile.component.html')
})
export class ServiceProfileComponent implements OnInit, OnChanges {

  @Input() public serviceItemDetail: ServiceItemDetailVM;
  public coverImage: ImageVM;
  public imageUrl: string;
  public full_description_title: string;
  public agreement_title: string;
  public showPrice: boolean = true;

  /**
   * TypeScript public modifiers
   */
  constructor(private sharingService: SharingService, private companyService: CompanyService, private alertService: AlertService) {
    let parent = this;
    companyService.getCompanyInfo().subscribe(function (com) {
      parent.full_description_title = companyService.getCompanyCustomSetting(com, "fullDescriptionTitle");
      parent.agreement_title = companyService.getCompanyCustomSetting(com, "agreementTitle");

      let priceViewMode = parent.companyService.getCompanyCustomSetting(com, 'priceViewMode');
      if (priceViewMode && priceViewMode.toLowerCase() == 'hide')
          parent.showPrice = false;

    })
  }

  public imageList: ImageVM[];

  public ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    let parent = this;
    parent.getServiceImage(this.serviceItemDetail);

  }

  shareCompanyUrl() {
    let url = this.companyService.getUrl();
    this.sharingService.copyToClipboard(url);
  }

  getServiceImage(si: ServiceItemDetailVM) {

    let parent = this;
    if (si && si.imageAlbum && si.imageAlbum.imageList && si.imageAlbum.imageList.length > 0 && !parent.coverImage) {

      parent.coverImage = si.imageAlbum.imageList[0];

    }
    else {
      parent.companyService.getCompanyInfo().subscribe((com) => {
        parent.imageUrl = parent.companyService.makeImageUrl('service', parent.coverImage, com.activityType, false);
      })
    }
  }

  openRuleDialog() {
    let title = "قوانین و مقررات";
    if (this.agreement_title) {
      title = this.agreement_title
    }
    this.alertService.showDialog(title, this.serviceItemDetail.agreement.rules)
  }

  openDescDialog() {
    let title = "شرح کامل";
    if (this.full_description_title) {
      title = this.full_description_title;
    }
    this.alertService.showDialog(title, this.serviceItemDetail.fullDescription);
  }

  shareServiceUrl() {
    let url = this.companyService.getUrl();
    this.sharingService.copyToClipboard(url);
    //this.companyService.getCompanyfullWebSiteUrl().subscribe(companyurl=> {
    //  let serviceUrl = companyurl + '/#/book?id=' + this.serviceItemDetail.id;
    //  this.sharingService.copyToClipboard(serviceUrl);
    //});

  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/service-profile/service-profile.component.ts